"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ReceptionBell = function ReceptionBell(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-259.000000, -5686.000000)",
    stroke: fill,
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(250.000000, 5252.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0.000000, 425.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.5394737,3.07894737 L19.3342105,6.72280702 C19.2918202,7.47614279 18.6467568,8.052478 17.8934211,8.01008772 C17.1400853,7.96769744 16.5637501,7.32263402 16.6061404,6.56929825 L16.754386,4.01578947 L11.1850877,9.6122807 C10.8533635,9.94541521 10.3691125,10.0762714 9.91474745,9.95555704 C9.4603824,9.83484268 9.10493212,9.48089713 8.9822913,9.02704826 C8.85965049,8.57319939 8.98845119,8.08839765 9.32017544,7.75526316 L13.4964912,3.55877193 L12.5605263,2.63157895 C11.8877749,1.96434574 11.4787482,1.07651173 11.4087719,0.131578947"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "5.67719298",
    y1: "11.972807",
    x2: "5.67719298",
    y2: "14.604386"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "2.3877193",
    y1: "11.972807",
    x2: "8.96666667",
    y2: "11.972807"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.11929825,19.8675439 C0.928608154,19.8673855 0.747342236,19.7846061 0.622344582,19.640598 C0.497346928,19.49659 0.44088272,19.3054838 0.46754386,19.1166667 C0.839847148,16.5257031 3.05961741,14.6020988 5.67719298,14.6020988 C8.29476855,14.6020988 10.5145388,16.5257031 10.8868421,19.1166667 C10.9137608,19.305471 10.8575367,19.4966756 10.732703,19.6408568 C10.6078693,19.7850381 10.4266782,19.8680448 10.2359649,19.8684211 L1.11929825,19.8675439 Z"
  })))))));
};
ReceptionBell.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
ReceptionBell.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = ReceptionBell;